import {

  CORE_LOAD_CONTACT_US_REQUEST,
  CORE_LOAD_CONTACT_US_SUCCESS,

  CORE_UPDATE_CONTACT_US_REQUEST,
  CORE_UPDATE_CONTACT_US_SUCCESS,
} from '../../../types'

const initialState = {}
export default {
  contactus: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_CONTACT_US_REQUEST:
      case CORE_UPDATE_CONTACT_US_REQUEST:
        return initialState

      case  CORE_LOAD_CONTACT_US_SUCCESS:
      case CORE_UPDATE_CONTACT_US_SUCCESS:
        return action.payload

      default:
        return state
    }
  }
}


// WEBPACK FOOTER //
// ./src/features/settings/contact/reducer.js